(function ($) {
  $(document).ready(() => {
    // const sPageURL = window.location.search.substring(1);
    const pathParam = decodeURIComponent(window.location.search.substring(1));

    const latestBlogItem = $(
      '.pageBlog__viewWrapper .overviewBlogItem--page:nth-of-type(4)',
    );

    if (pathParam === '' || pathParam === 'page=0') {
      latestBlogItem.remove();
    }
  });
}(jQuery));
